import styled from 'styled-components';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { BodyM } from 'atoms/typography';
import { SocialLinks } from 'atoms/ui/SocialMedias';
import { LanguageSwitcher } from 'components/user/LanguageSwitcher';
import { useIsLoggedIn } from 'hooks/auth/useIsLoggedIn';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import { copyright } from 'lib/copyright';
import { tabletAndAbove } from 'style/mediaQuery';

import { FooterLinks } from './FooterLinks';
import { SocialLinksConfig as socialLinks } from './socialLinks';

const Footer = styled.footer`
  background: var(--c-black);
  color: var(--c-white);
`;
const CopyAndLanguage = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--double-unit);
  padding: var(--double-unit) 0;
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;
const CopyContainer = styled(BodyM)`
  @media ${tabletAndAbove} {
    text-align: right;
  }
`;

export const MultiSportFooter = () => {
  const isLoggedIn = useIsLoggedIn();
  const { isMobileApp } = useIsMobileApp();

  if (isMobileApp) return null;

  if (isLoggedIn) return null;

  return (
    <Footer>
      <FullWidthContainer>
        <SocialLinks socialLinks={socialLinks} />
        <FooterLinks />
        <CopyAndLanguage>
          <LanguageSwitcher />
          <CopyContainer>{copyright}</CopyContainer>
        </CopyAndLanguage>
      </FullWidthContainer>
    </Footer>
  );
};
